export default "__VITE_ASSET__KYGyLLmD__"